'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import Orderbook from './Orderbook/Orderbook';
import RecentMarketTrades from './RecentMarketTrades';
import { cj } from 'src/utils/classNames';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { TabOption } from 'src/components/primitives/Tabs/types';
import type { TVChartContainerProps } from 'src/components/TradingView/types';

type MobileTradeTab = 'chart' | 'orderbook' | 'recentTrades';

const TVChartContainer = dynamic(
	() =>
		import('./TradingView').then(
			(mod) =>
				mod.TVChartContainer as React.ComponentType<TVChartContainerProps>
		),
	{ ssr: false }
);

const tabOptions: TabOption<MobileTradeTab>[] = [
	{ value: 'chart', label: 'Chart' },
	{ value: 'orderbook', label: 'Orderbook' },
	{ value: 'recentTrades', label: 'Recent Trades' },
];

const MobileChartAndOrderbook = () => {
	const [selectedTab, setSelectedTab] = useState<MobileTradeTab>('chart');
	const activeMobileView = useDriftStore((s) => s.activeMobileView);

	const handleChangeTabletTab = (tab: string) => {
		setSelectedTab(tab as MobileTradeTab);
	};

	return (
		<div className="relative flex h-full max-h-full flex-col">
			<Tabs
				options={tabOptions}
				activeTab={selectedTab}
				onTabChange={handleChangeTabletTab}
				className="bg-container-bg"
				indicatorTrack
			/>
			<div
				className={cj(
					'relative flex h-full w-full flex-col bg-container-bg',
					// We want to continuously render the chart section, so that it doesn't have to re-mount when we switch tabs.
					selectedTab !== 'chart' && 'hidden'
				)}
			>
				<TVChartContainer isMobileScreenSize />
			</div>
			{/* We also render an OB on the Trade view, and having two OB's in the DOM at
      the same time a) is wasteful and b) confuses `useDynamicOrderbookDepth`. */}
			{selectedTab === 'orderbook' && activeMobileView === 'chart' && (
				<Orderbook />
			)}
			{selectedTab === 'recentTrades' && <RecentMarketTrades />}
		</div>
	);
};

export default MobileChartAndOrderbook;
